import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import Toggle from './../Toggle';
import { withTranslation, Trans } from 'react-i18next';
import { aftcabinImageOptions } from './views/aftcabin'

class X49MK2AftCabin extends Component {
    constructor(props) {
        super(props);
        this.handleCabinChange = this.handleCabinChange.bind(this);
        this.handleCupboardsChange = this.handleCupboardsChange.bind(this);
    }


    handleCabinChange(newValue) {
        let configuration = this.props.configuration;
        configuration.SplitBerth = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleCupboardsChange(event) {
        let configuration = this.props.configuration;
        configuration.CupboardsAftCabin = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = aftcabinImageOptions;

        let image = <ConfiguratorImage boat="X4_9mk2" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Aft cabins' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='X49 Aft Cabins Furniture Text 1' /></p>
                    <p><Trans defaults='X49 Aft Cabins Furniture Text 2' /></p>
                    <p><Trans defaults='X49 Aft Cabins Furniture Text 3' /></p>
                    <RadioGroup options={this.props.aftCabinOptions} value={this.props.configuration.SplitBerth} onChange={this.handleCabinChange} />


                    <Toggle checked={this.props.configuration.CupboardsAftCabin.value === 2} onChange={this.handleCupboardsChange}>
                        <Trans defaults='Upper cupboards' />
                    </Toggle>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49MK2AftCabin);


// WEBPACK FOOTER //
// ./src/X49MK2/X49MK2-AftCabin.js